import { isRemoteSite, isProd } from 'env-utils';
import config from '../config/google-analytics-config.json';

export const initGoogleAnalytics = () => {
  if (!shouldTrack()) {
    return;
  }

  /* eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0] as any,
      j = d.createElement(s) as any,
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', config.tackingId);
  /* eslint-enable */
};

export const shouldTrack = () => isProd() && !isRemoteSite();
